import React, { useContext, useMemo } from 'react';
import { Navigate } from 'react-router-dom';

import { UserContext } from 'components/shared/context/UserContextProvider';

interface SignedInProps {
  children?: React.ReactNode;
}

const SignedIn: React.FC<SignedInProps> = ({ children }) => {
  const { userState } = useContext(UserContext);

  const isSignedInValue = useMemo(() => userState.token, [userState.token]);

  return (
    <>
      {isSignedInValue ? children : <Navigate to="/sign-in" replace={true} />}
    </>
  );
};

export default SignedIn;
